import { TThunkAction } from '../../types/redux';
import { ILocation } from '../../types/location';
import { prepareLocations } from '../../mappers/prepareLocations';
import {
  fetchSearchRegionsCities,
  TSearchRegionsCitiesResponse,
} from '../../repositories/geo-temp-layer/v1/search-regions-cities';

export interface IGetRegionsParams {
  request: string;
}

export const getLocations = (params: IGetRegionsParams): TThunkAction<Promise<ILocation[]>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;
    const defaultData: ILocation[] = [];

    try {
      const regionsData: TSearchRegionsCitiesResponse = await fetchSearchRegionsCities({
        httpApi,
        parameters: {
          query: params.request,
        },
      });

      if (regionsData.statusCode === 200) {
        return prepareLocations(regionsData.response.items);
      }

      if (regionsData.statusCode !== 400) {
        logger.error('Unable to retrieve location data');
      }

      return defaultData;
    } catch (error) {
      logger.error(error);

      return defaultData;
    }
  };
};
